import { useMemo } from 'react';
import { StepType } from '@/types/automationFields.ts';
import { TriggerStep } from '@/types/automationSteps.ts';

import { AutomationVersion } from '@/types/automations.ts';

const useTriggerStep = (automationVersion?: AutomationVersion | null, triggerId?: string) => {
  return useMemo(() => {
    return automationVersion?.steps.find(
      (step) =>
        step.step_type === StepType.Trigger && Boolean(triggerId) && step.step_id === triggerId,
    ) as TriggerStep | undefined;
  }, [automationVersion, triggerId]);
};

export default useTriggerStep;
